/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1LocationStates202,
  PostApiV1LocationStates400,
  PostApiV1LocationStates401,
  PostApiV1LocationStates404,
  PostApiV1LocationStates409,
  PostApiV1LocationStates500,
  PostApiV1LocationStatesMutationRequest,
  PostApiV1LocationStatesMutationResponse,
} from "../../types/locationStateController/PostApiV1LocationStates.ts";
import { createStateRequestViewModelSchema } from "../createStateRequestViewModelSchema.ts";
import { stateViewModelSchema } from "../stateViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1LocationStates202Schema = z.lazy(
  () => stateViewModelSchema,
) as unknown as ToZod<PostApiV1LocationStates202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1LocationStates400Schema =
  z.any() as unknown as ToZod<PostApiV1LocationStates400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1LocationStates401Schema =
  z.any() as unknown as ToZod<PostApiV1LocationStates401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1LocationStates404Schema =
  z.any() as unknown as ToZod<PostApiV1LocationStates404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1LocationStates409Schema =
  z.any() as unknown as ToZod<PostApiV1LocationStates409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1LocationStates500Schema =
  z.any() as unknown as ToZod<PostApiV1LocationStates500>;

export const postApiV1LocationStatesMutationRequestSchema = z.lazy(
  () => createStateRequestViewModelSchema,
) as unknown as ToZod<PostApiV1LocationStatesMutationRequest>;

export const postApiV1LocationStatesMutationResponseSchema = z.lazy(
  () => postApiV1LocationStates202Schema,
) as unknown as ToZod<PostApiV1LocationStatesMutationResponse>;
